import {Injectable} from '@angular/core';
import {HttpClientWrapperService} from '../config/http-client-wrapper.service';
import {AuthService} from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class IntroductionLetterService {

    constructor(private http: HttpClientWrapperService,
                private authService: AuthService) {
    }

    getInsuranceInfo(insuranceNumber: string) {
        return this.http.post('insurance-service/statistics/getInsuranceByNumber', {insuranceNumber}, this.authService.decode().auth);
    }

    getClientProductList() {
        return this.http.get('insurance-service/statistics/getProducts', this.authService.decode().auth);
    }

    getOfferList(companyName: string, insuranceProductName: string) {
        return this.http.get(`insurance-service/statistics/getOffers/${insuranceProductName}/${companyName}`,
            this.authService.decode().auth);
    }

    create(insurance: any) {
        return this.http.post('insurance-service/requests/create', insurance, this.authService.decode().auth);
    }

    getInsuranceInfoById(id: number, productName: string) {
        return this.http.get(`insurance-service/statistics/${productName}/${id}`, this.authService.decode().auth);
    }

    uploadFile(selectedFormID: number, fileEnglishLabel: string, file: File, productName: string) {
        return this.http.upload(`insurance-service/file-control/${productName}?fileType=${fileEnglishLabel}&formID=${selectedFormID}`,
            file, fileEnglishLabel, this.authService.decode().auth);
    }

    downloadLetter(formID: number) {
        return this.http.get(`insurance-service/file-control/download-letter/${formID}`, this.authService.decode().auth);
    }

    createNewLetterRequest(form: {
        letterTypeID: number,
        subsetID: number,
        healthCenterName: string,
        stateID: number,
        cityID: number
    }) {
        return this.http.post(`insurance-service/requests/INTRODUCTION_LATTER/createNewRequest`, form, this.authService.decode().auth);
    }

    getLetterTypeList(insuranceProductName: string) {
        return this.http.get(`insurance-service/statistics/type-list/${insuranceProductName}`, this.authService.decode().auth);
    }

    getOfferSupportList(insuranceID: number) {
        return this.http.get(`insurance-service/statistics/get-support-list?insuranceID=${insuranceID}`, this.authService.decode().auth);
    }

    createNewRecompenseRequest(form: {
        stateID: number,
        cityID: number,
        subsetID: number,
        dateOfDamage: string,
        reason: string,
        amount: number
    }) {
        return this.http.post(`insurance-service/requests/RECOMPENSE/createNewRequest`, form, this.authService.decode().auth);
    }
}
